// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const ConnectionErrorTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.embed.connectionErrorTitle"
        description="Connection error title."
        defaultMessage="Connection Error"
    />
);
ConnectionErrorTitle.displayName = "ConnectionErrorTitle";

export const BridgeTimeout = (): ReactElement => (
    <FormattedMessage
        id="apps.embed.bridgeTimeout"
        description="Bridge timeout."
        defaultMessage="Connection timed out. Please reopen the Remote Assets panel."
    />
);
BridgeTimeout.displayName = "BridgeTimeout";

export const BridgeNotFound = (): ReactElement => (
    <FormattedMessage
        id="apps.embed.bridgeNotFound"
        description="Bridge not found."
        defaultMessage="Bridge not available. Please update Lens Studio."
    />
);
BridgeNotFound.displayName = "BridgeNotFound";

export const AuthRequiredTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.embed.authRequiredTitle"
        description="Auth required title."
        defaultMessage="Authentication Required"
    />
);
AuthRequiredTitle.displayName = "AuthRequiredTitle";

export const AuthRequiredMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.embed.authRequiredMessage"
        description="Auth required message."
        defaultMessage="Please log in and retry."
    />
);
AuthRequiredMessage.displayName = "AuthRequiredMessage";

export const UnauthorizedTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.embed.unauthorizedTitle"
        description="Unauthorized title."
        defaultMessage="Session Expired"
    />
);
UnauthorizedTitle.displayName = "UnauthorizedTitle";

export const UnauthorizedMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.embed.unauthorizedMessage"
        description="Unauthorized message."
        defaultMessage="Your session has expired. Please reopen the Remote Assets panel."
    />
);
UnauthorizedMessage.displayName = "UnauthorizedMessage";

export const RemoteAssetsDocsLink = (): ReactElement => (
    <FormattedMessage
        id="apps.embed.remoteAssetsDocsLink"
        description="Remote assets docs link."
        defaultMessage="Remote Assets documentation"
    />
);
RemoteAssetsDocsLink.displayName = "RemoteAssetsDocsLink";

export const EmbedGenericErrorTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.embed.embedGenericErrorTitle"
        description="Embed generic error title."
        defaultMessage="Something went wrong"
    />
);
EmbedGenericErrorTitle.displayName = "EmbedGenericErrorTitle";

export const EmbedGenericErrorMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.embed.embedGenericErrorMessage"
        description="Embed generic error message."
        defaultMessage="An unexpected error occurred. Please try again."
    />
);
EmbedGenericErrorMessage.displayName = "EmbedGenericErrorMessage";

export const EmbedErrorReload = (): ReactElement => (
    <FormattedMessage id="apps.embed.embedErrorReload" description="Embed error reload." defaultMessage="Reload" />
);
EmbedErrorReload.displayName = "EmbedErrorReload";
